import { NavLink, useNavigate, useLocation } from "react-router-dom"
import { usePatient } from "../context/PatientContext"
import { useUser } from "../context/UserContext"
import { useState, useEffect, useRef } from "react"

function Navbar() {
  const { patient } = usePatient()
  const { user, setUser } = useUser()
  const location = useLocation()
  const navigate = useNavigate()
  const [menuAbierto, setMenuAbierto] = useState(false)
  const menuRef = useRef(null)

  const isPatientProfile =
    location.pathname.startsWith("/pacientes/") &&
    location.pathname !== "/pacientes"

  const isAdmin = user?.role === "ADMIN"

  const logout = () => {
    localStorage.removeItem("token")
    localStorage.removeItem("usuario")
    setUser(null)
    navigate("/login")
  }

  // Cerrar al navegar
  useEffect(() => { setMenuAbierto(false) }, [location.pathname])

  // Cerrar al clickear fuera
  useEffect(() => {
    if (!menuAbierto) return
    const handler = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setMenuAbierto(false)
    }
    document.addEventListener("mousedown", handler)
    return () => document.removeEventListener("mousedown", handler)
  }, [menuAbierto])

  return (
    <div className="navbar row spacebetween">
      {/* Breadcrumb — siempre visible */}
      <div className="navbarPath row alignStart">
        <NavLink
          to="/"
          className={({ isActive }) => isActive ? "nav-item navActive" : "nav-item"}
        >
          <i className={`fa-solid ${isPatientProfile ? "fa-circle-arrow-left" : "fa-house"}`} /> inicio
        </NavLink>

        {isPatientProfile && patient && (
          <>
            <span> / </span>
            <span className="navbarSelectedPatient">
              {patient.apellido}, {patient.nombre}
            </span>
          </>
        )}
      </div>

      {/* Acciones — desktop */}
      <div className="navbarLog row alignEnd navbarDesktop">
        {isAdmin && (
          <div className="navbarAdminActions row">
            <NavLink to="/admin" className={({ isActive }) => `navbarAdminBtn${isActive ? " navbarAdminBtn--active" : ""}`}>
              PANEL DE ADMINISTRACIÓN
            </NavLink>
          </div>
        )}
        <NavLink to="/cambiar-password" title="Cambiar contraseña" className="navbarIconBtn">
          <i className="fa-solid fa-gear"></i>
        </NavLink>
        <i className="fa-solid fa-arrow-right-from-bracket navbarIconBtn" title="Desconectarse" onClick={logout}></i>
      </div>

      {/* Hamburguesa — mobile */}
      <div className="navbarHamburger" ref={menuRef}>
        <button
          className="navbarHamburgerBtn"
          onClick={() => setMenuAbierto(v => !v)}
          aria-label="Menú"
        >
          <i className={`fa-solid fa-${menuAbierto ? "xmark" : "bars"}`}></i>
        </button>

        {menuAbierto && (
          <div className="navbarHamburgerMenu column">
            {isAdmin && (
              <NavLink
                to="/admin"
                className={({ isActive }) => `navbarHamburgerItem${isActive ? " navbarHamburgerItem--active" : ""}`}
              >
                <i className="fa-solid fa-table-columns"></i>
                Panel de administración
              </NavLink>
            )}
            <NavLink to="/cambiar-password" className="navbarHamburgerItem">
              <i className="fa-solid fa-gear"></i>
              Cambiar contraseña
            </NavLink>
            <button className="navbarHamburgerItem navbarHamburgerItem--logout" onClick={logout}>
              <i className="fa-solid fa-arrow-right-from-bracket"></i>
              Cerrar sesión
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default Navbar
